import { defineStore } from 'pinia'

export const useVersionDataStore = defineStore('versionDataStore', {
  state: () => ({
    versionData: null
  })
})
